import * as z from "zod/v4";

const utmSchema = z.object({
	utm_source: z.string().optional(),
	utm_medium: z.string().optional(),
	utm_campaign: z.string().optional(),
	utm_content: z.string().optional(),
	utm_term: z.string().optional()
});

export function getUtmData(data: unknown) {
	const utmData = utmSchema.parse(data);
	const hasUtmData = Object.values(utmData).some((value) => value !== undefined && value !== "");

	return { utmData, hasUtmData };
}

export function formatPhoneNumber(value: string): string {
	// Remove all non-digit characters
	let digits = value.replace(/\D/g, "");

	// Strip leading "1" if it's an 11-digit number (US country code)
	if (digits.length === 11 && digits[0] === "1") {
		digits = digits.slice(1);
	}

	// Limit to 10 digits
	const trimmed = digits.slice(0, 10);

	// Format as (XXX) XXX-XXXX
	if (trimmed.length === 0) return "";
	if (trimmed.length <= 3) return `(${trimmed}`;
	if (trimmed.length <= 6) return `(${trimmed.slice(0, 3)}) ${trimmed.slice(3)}`;
	return `(${trimmed.slice(0, 3)}) ${trimmed.slice(3, 6)}-${trimmed.slice(6)}`;
}

export function scrollIntoView(sectionId: string) {
	const element = document.getElementById(sectionId);
	if (!element) return;
	const elPosition = element.getBoundingClientRect();
	const offsetPosition = elPosition.top + window.scrollY - 81;

	window.scrollTo({
		top: offsetPosition,
		behavior: "smooth"
	});
}
